import React, { useRef, useState, useEffect } from "react";
import Apiservice from "../Apiservice";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import { PDFDownloadLink } from "@react-pdf/renderer";
import IncidentReportPDF from "./IRPDF";
import { formatDate, formatDateForInput } from "../Utils/Utils"

const IncidentReportView = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const incidentReportId = location.state?.id;

    const [loggedRoleId, setLoggedRoleId] = useState(0)

    const [userId, setUserId] = useState(0);
    const [userDetails, setUserDetails] = useState([]);

    const [siteId, setSiteId] = useState(0);
    const [siteName, setSiteName] = useState("");

    // Refs for single line inputs
    const informantNameRef = useRef("");
    const informantNRICRef = useRef("");
    const locationRef = useRef("");
    const placeRef = useRef("");
    const whatRef = useRef("");
    const whenRef = useRef("");
    const whereRef = useRef("");
    const whoRef = useRef("");
    const howRef = useRef("");
    const whyRef = useRef("");
    const securityImplicationsRef = useRef("");
    const vehicleRef = useRef("");
    const departmentRef = useRef("");

    // Date & time
    const [date, setDate] = useState("");
    const [time, setTime] = useState("");

    // Arrays
    const [whoWasInvolved, setWhoWasInvolved] = useState([]);
    const [nameAndRank, setNameAndRank] = useState([{ name: "", rank: "" }]);
    const [actionsTaken, setActionsTaken] = useState([""]);
    const [recommandation, setRecommandation] = useState([""]);

    const [update, setUpdate] = useState(false);
    const handleUpdateButton = async () => {
        setUpdate(!update);
    }

    const toInvolvePersons = [
        "57 Peace Protection Command Centre",
        "Site Management",
        "24hours Central Monitoring Centre",
        "JTC Command Centre (Jurong island)",
        "SCDF",
        "Police",
        "AETOS (Jurong Island)",
        "Site Cleaner",
        "Site Technician",
        "Others",
    ];

    // Simulate fetching user & site details
    useEffect(() => {
        const fetchData = async () => {
            let result = await Apiservice.IncidentReportGet({ "id": incidentReportId, "status": 0 });

            if (result.success === true) {
                let data = result.data[0];
                setSiteId(data.siteId)
                setSiteName(data.siteDetails[0].name);
                setUserId(data.userId);
                let date = formatDateForInput(data.date);
                setDate(date);
                locationRef.current.value = data.location;
                informantNameRef.current.value = data.informantName;
                informantNRICRef.current.value = data.informantNRIC;
                placeRef.current.value = data.place;

                setTime(data.time);
                whatRef.current.value = data.what;
                whenRef.current.value = data.when;
                whereRef.current.value = data.where;
                whoRef.current.value = data.who;
                howRef.current.value = data.how;
                whyRef.current.value = data.why;
                securityImplicationsRef.current.value = data.securityImplications;
                setWhoWasInvolved(data.whoWasInvolved);

                setNameAndRank(
                    Array.isArray(data.nameAndRank)
                        ? data.nameAndRank
                        : JSON.parse(data.nameAndRank || "[]")
                );

                vehicleRef.current.value = data.vehicleNumber;
                departmentRef.current.value = data.department;

                setActionsTaken(
                    Array.isArray(data.actionsTaken)
                        ? data.actionsTaken
                        : JSON.parse(data.actionsTaken || "[]")
                );

                setRecommandation(
                    Array.isArray(data.recommendation)
                        ? data.recommendation
                        : JSON.parse(data.recommendation || "[]")
                );

                let roleId = localStorage.getItem("role_id");
                setSiteName(data.siteDetails[0].name)
                setLoggedRoleId(roleId);


            } else {
                alert(result.message);
            }

        }; fetchData();
    }, [incidentReportId]);

    // Handle involved persons checkbox
    const handleInvolvedChange = (person) => {
        setWhoWasInvolved((prev) =>
            prev.includes(person)
                ? prev.filter((p) => p !== person)
                : [...prev, person]
        );
    };

    // Handle name and rank dynamic fields
    const handleNameRankChange = (index, field, value) => {
        const updated = [...nameAndRank];
        updated[index][field] = value;
        setNameAndRank(updated);
    };

    const addNameRankRow = () => {
        setNameAndRank([...nameAndRank, { name: "", rank: "" }]);
    };

    // Handle actionsTaken & recommendation
    const handleArrayChange = (index, value, setter, arr) => {
        const updated = [...arr];
        updated[index] = value;
        setter(updated);
    };

    const addArrayRow = (setter, arr) => {
        setter([...arr, ""]);
    };

    const handleUpdate = async () => {
        const data = {
            incidentReportId: incidentReportId,
            userId: userId,
            siteId: siteId,
            informantName: informantNameRef.current?.value || "",
            informantNRIC: informantNRICRef.current?.value || "",
            place: placeRef.current?.value || "",
            location: locationRef.current?.value || "",
            date: date,
            time: time,
            what: whatRef.current?.value || "",
            when: whenRef.current?.value || "",
            where: whereRef.current?.value || "",
            who: whoRef.current?.value || "",
            how: howRef.current?.value || "",
            why: whyRef.current?.value || "",
            securityImplications: securityImplicationsRef.current?.value || "",
            vehicleNumber: vehicleRef.current?.value || "",
            department: departmentRef.current?.value || "",
            whoWasInvolved,
            nameAndRank,
            actionsTaken,
            recommandation, // fixed typo
        };

        let result = await Apiservice.IncidentReportUpdate(data);

        if (result.success === true) {
            Swal.fire({
                title: "Incident Report Updated!",
                text: result.message,
                icon: "success",
            });
            navigate('/incidentreport');
        } else {
            Swal.fire({
                title: "Error",
                text: result.message,
                icon: "error",
            });
        }
    };

    const handleSoftDelete = async () => {

        Swal.fire({
            title: "Are you sure want to delete?",
            // text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                let result = await Apiservice.IncidentReportSoftDelete({ "incidentReportId": incidentReportId })
                if (result.success === true) {
                    Swal.fire({
                        title: "Deleted!",
                        text: "Your file has been deleted.",
                        icon: "success"
                    });
                    navigate('/incidentreport')
                } else {
                    Swal.fire({
                        title: "Not Deleted!",
                        icon: "Error"
                    });
                }

            }
        });
    }

    return (
        <div className="container-fluid card shadow">
            <div
                className="row align-items-center mb-3 bg-white p-2 m-2"
                style={{ position: "sticky", top: "0", zIndex: 1000 }}
            >
                <div className="col">
                    <h3 className="mb-0 text-center">Incident Report</h3>
                </div>
                <div className="col-auto ms-auto">
                    <PDFDownloadLink
                        document={<IncidentReportPDF data={{
                            place: placeRef.current?.value,
                            location: locationRef.current?.value,
                            date: date,
                            time: time,
                            informantName: informantNameRef.current?.value,
                            informantNRIC: informantNRICRef.current?.value,
                            what: whatRef.current?.value,
                            when: whenRef.current?.value,
                            where: whereRef.current?.value,
                            who: whoRef.current?.value,
                            how: howRef.current?.value,
                            why: whyRef.current?.value,
                            securityImplications: securityImplicationsRef.current?.value,
                            whoWasInvolved,
                            nameAndRank,
                            vehicleNumber: vehicleRef.current?.value,
                            department: departmentRef.current?.value,
                            actionsTaken,
                            recommandation,
                        }} />}
                        fileName={`IncidentReport_${date}.pdf`}
                        style={{ textDecoration: "none" }}
                    >
                        {({ loading }) =>
                            loading ? "Generating PDF..." : <button className="btn btn-sm btn-primary me-2">Download PDF</button>
                        }
                    </PDFDownloadLink>
                    {
                        (loggedRoleId === 1 || loggedRoleId === '1') && (
                            <>
                                <button className="btn btn-sm btn-success me-2" onClick={handleUpdateButton}>Update</button>
                                <button className="btn btn-sm btn-danger" onClick={() => handleSoftDelete()}>Delete</button>
                            </>

                        )
                    }

                </div>
            </div>


            <div className="row card shadow p-2 m-2">
                <div className="row">
                    <div className="col"><u>PART A : INCIDENT DETAILS</u></div>
                </div>
                <div className="row mb-2">
                    <div className="col">
                        <div className="row">
                            <div className="col">Site </div>
                            <div className="col">
                                <input
                                    type="text"
                                    value={siteName}
                                    className="form-control form-control-sm"
                                    disabled={update === false}

                                />
                            </div>

                        </div>
                    </div>
                    <div className="col">
                        <div className="row">
                            <div className="col">Date </div>
                            <div className="col">
                                <input type="date" name="" id=""
                                    value={date}
                                    max={new Date().toISOString().split("T")[0]}   // <-- Prevent future dates
                                    className="form-control form-control-sm"
                                    disabled={update === false}
                                    onChange={(e) => setDate(e.target.value)} />
                            </div>

                        </div>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col">
                        <div className="row">
                            <div className="col">Place Of Incident</div>
                            <div className="col">
                                <input
                                    type="text"
                                    ref={placeRef}
                                    className="form-control form-control-sm"
                                    disabled={update === false}

                                />
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="row">
                            <div className="col">Location</div>
                            <div className="col">
                                <input type="text" name="" id="" ref={locationRef} className="form-control form-control-sm" disabled={update === false} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col">
                        <div className="row">
                            <div className="col">Name of Informant</div>
                            <div className="col">
                                <input type="text" name="" id="" ref={informantNameRef} className="form-control form-control-sm" disabled={update === false} />
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="row">
                            <div className="col">Informant NRIC</div>
                            <div className="col">
                                <input type="text" name="" id="" ref={informantNRICRef} className="form-control form-control-sm" disabled={update === false} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col">
                        <div className="row">
                            <div className="col-3">Time of incident</div>
                            <div className="col">
                                <input type="time" name="" id="" value={time} onChange={(e) => setTime(e.target.value)} className="form-control form-control-sm" disabled={update === false} />
                            </div>
                        </div>
                    </div>

                </div>

            </div>



            {/* Sections */}
            {[
                { label: <u>PART B : What Happened?</u>, ref: whatRef },
                { label: <u>PART C : When Did It Happen?</u>, ref: whenRef },
                { label: <u>PART D : Where Did It Happen?</u>, ref: whereRef },
                { label: <u>PART E : Who Was Involved?</u>, ref: whoRef },
                { label: <u>PART F : How Did It Happen?</u>, ref: howRef },
                { label: <u>PART G : Why Did It Happen?</u>, ref: whyRef },
                {
                    label: <u>`PART H : IS THERE ANY SECURITY IMPLICATION DUE
                        TO THE INCIDENT?(SECURITY INVOLVEMENT) IF YES, WHAT WERE THE ACTION TAKEN.
                        PLEASE EXPLAIN`</u>, ref: securityImplicationsRef
                },
            ].map((f, i) => (
                <div className="row card shadow p-2 m-2" key={i}>
                    <div className="row">
                        <div className="col">{f.label}</div>
                    </div>

                    <div className="row">
                        <div className="col">
                            <textarea
                                ref={f.ref}
                                className="form-control form-control-sm"
                                rows={3} // initial number of visible lines
                                style={{ resize: "vertical" }} // allows vertical resizing if needed
                                disabled={update === false}
                            />
                        </div>
                    </div>

                </div>
            ))}

            {/* Checkbox List */}
            <div className="row mb-3 card shadow p-2 m-2">
                <u>PART I : WHO WAS INVOLVED</u>
                <div className="row ">
                    {toInvolvePersons.map((p, i) => (
                        <div className="col-6" key={i}>
                            <label>
                                <input
                                    type="checkbox"
                                    className="form-check-input me-1"
                                    checked={whoWasInvolved.includes(p)}
                                    onChange={() => handleInvolvedChange(p)}
                                    disabled={update === false}
                                />
                                {p}
                            </label>
                        </div>
                    ))}
                </div>
            </div>

            {/* Name & Rank */}
            <div className="row mb-3 card shadow p-2 m-2">
                <u>PART J : PARTICULARS OF "WHO WAS INVOLVED" (PART I)</u>
                <table className="table table-borderless">
                    <tbody>
                        <tr>
                            <td style={{ width: "200px" }}>Name & RANK (If Any)</td>
                            <td>
                                {/* {console.log("nameAndrank", nameAndRank)}; */}
                                {Array.isArray(nameAndRank) && nameAndRank.map((nr, i) => (
                                    <div className="row mb-2" key={i}>
                                        <div className="col">
                                            <input
                                                placeholder="Name"
                                                value={nr.name}
                                                onChange={(e) =>
                                                    handleNameRankChange(i, "name", e.target.value)
                                                }
                                                className="form-control form-control-sm"
                                                disabled={update === false}
                                            />
                                        </div>
                                        <div className="col">
                                            <input
                                                placeholder="Rank"
                                                value={nr.rank}
                                                onChange={(e) =>
                                                    handleNameRankChange(i, "rank", e.target.value)
                                                }
                                                className="form-control form-control-sm"
                                                disabled={update === false}
                                            />
                                        </div>
                                    </div>
                                ))}{
                                    update === true && (
                                        <button
                                            className="btn btn-sm btn-secondary mt-1"
                                            onClick={addNameRankRow}
                                        >
                                            + Add Row
                                        </button>
                                    )
                                }

                            </td>
                        </tr>

                        <tr>
                            <td>Vehicle Number</td>
                            <td>
                                <input ref={vehicleRef} className="form-control form-control-sm" disabled={update === false} />
                            </td>
                        </tr>

                        <tr>
                            <td>Department</td>
                            <td>
                                <input ref={departmentRef} className="form-control form-control-sm" disabled={update === false} />
                            </td>
                        </tr>

                        <tr>
                            <td>Actions Taken</td>
                            <td>
                                {Array.isArray(actionsTaken) && actionsTaken.map((a, i) => (
                                    <div className="row mb-2" key={i}>
                                        <div className="col">
                                            <input
                                                value={a}
                                                onChange={(e) =>
                                                    handleArrayChange(
                                                        i,
                                                        e.target.value,
                                                        setActionsTaken,
                                                        actionsTaken
                                                    )
                                                }
                                                className="form-control form-control-sm"
                                                disabled={update === false}
                                            />
                                        </div>
                                    </div>
                                ))}
                                {
                                    update === true && (
                                        <button
                                            className="btn btn-sm btn-secondary mt-1"
                                            onClick={() =>
                                                addArrayRow(setActionsTaken, actionsTaken)
                                            }
                                        >
                                            + Add Action
                                        </button>
                                    )
                                }

                            </td>
                        </tr>

                        <tr>
                            <td>Recommendation</td>
                            <td>
                                {Array.isArray(recommandation) &&
                                    recommandation.map((r, i) => (
                                        <div className="row mb-2" key={i}>
                                            <div className="col">
                                                <input
                                                    type="text"
                                                    value={r || ""}   // ✅ ensure controlled input
                                                    onChange={(e) =>
                                                        handleArrayChange(
                                                            i,
                                                            e.target.value,
                                                            setRecommandation,
                                                            recommandation
                                                        )
                                                    }
                                                    className="form-control form-control-sm"
                                                    disabled={!update}
                                                />
                                            </div>
                                        </div>
                                    ))}

                                {update && (
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-secondary mt-1"
                                        onClick={() =>
                                            addArrayRow(setRecommandation, recommandation)
                                        }
                                    >
                                        + Add Recommendation
                                    </button>
                                )}
                            </td>

                        </tr>
                    </tbody>
                </table>
            </div>
            {
                update === true && (
                    <div className="row mb-3 p-2 m-2">
                        <div className="col text-center">
                            <button className="btn btn-primary col-md-8" onClick={handleUpdate}>
                                Update Report
                            </button>
                        </div>
                    </div>
                )
            }

        </div>
    );
};

export default IncidentReportView;
